const searchByName = (text, list) => {
  const searchText = text.trim().replace(/^0+/, '');

  if (searchText.length <= 0) return [];

  return list.filter(
    (o) =>
      o.name
        .trim()
        .normalize('NFD') // decompose combined graphemes
        .replace(/[\u0300-\u036f]/g, '') // gets rid of diacritics
        .replace(/^0+/, '')
        .toUpperCase()
        .indexOf(
          searchText
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toUpperCase(),
        ) !== -1,
  );
};

export default searchByName;
